import type { TranslationMessages } from '../../types';

export const pin: TranslationMessages = {
  pin_tab: 'Ghim tab',
  unpin_tab: 'Bỏ ghim tab',
  pinned: 'Đã ghim',
  pin: 'Ghim',
};
